import { PageRef } from 'providers/page-ref';

export type IntroCarouselPageParams = {};

export const IIntroCarouselPage: PageRef<IntroCarouselPageParams, void> = {
  pageName: 'IntroCarouselPage',
} as PageRef<IntroCarouselPageParams, void>;
